/* eslint-disable */
import { GetterTree } from "vuex";
import { Company } from "@/models/company";
import { Pagination } from "@/models/pagination";
import { RootState } from "@/types";
import { CompanyState } from "@/types/company";

const getters: GetterTree<CompanyState, RootState> = {
  list: (state) => {
    return state.pagination ? state.pagination.data : [];
  },
  pagination: (state) => {
    return state.pagination || new Pagination();
  },
  single: (state) => {
    return state.single || new Company();
  },
  // selectItem: (state) => {
  //   return state.pagination
  //     ? state.pagination.data.map((user) => Company.toSelectItem(user))
  //     : [];
  // },
  // isSale: (state) => {
  //   return state.user?.abilities;
  // }
  // isSale: (state) => state.user!.abilities === "role:sale",
  // isAdmin: state => 0 < state.user!.role && state.user!.role <= 5,
  // isUser: state => 5 < state.user!.role
  // && state.user!.role <= 10,
  // isCustomer: state => 10 < state.user!.role
};

export default getters;
